import useLayoutData from "./useLayoutData";
import { codeToCountry, CountryCodesNum } from "../utils/countries";
import { CountryConfig, countryConfig } from "../utils/countryConfig";
import { CountryCode } from "../utils/enum";

type Props = CountryConfig & {
  isDutch: boolean;
  isBelgium: boolean;
  isTurkiye: boolean;
};

const useCountryConfigHook = (customCountryCode?: CountryCodesNum): Props => {
  const { country: countryCode } = useLayoutData();
  const country = codeToCountry[customCountryCode || countryCode];
  const config = countryConfig[country || "NETHERLANDS"];

  return {
    ...config,
    isDutch: countryCode === CountryCode.NETHERLANDS,
    isBelgium: countryCode === CountryCode.BELGIUM,
    isTurkiye: countryCode === CountryCode.TURKIYE,
  };
};

export default useCountryConfigHook;
